export default __webpack_public_path__ + "static/media/program-link-project.d193b20f.svg";